module.exports = __webpack_public_path__ + "img/woman11.b492148d.png";